import productFactsJson from "./productFacts.json";

export type FactSourceKind = "manufacturer" | "aurora" | "packaging";

export interface FactSource {
  url: string;
  dateChecked: string;
  kind: FactSourceKind;
}

export interface SourcedText {
  text: string;
  source: FactSource | null;
}

export interface SourcedIngredients {
  items: string[];
  source: FactSource | null;
}

export interface ProductFactComponent {
  name: string;
  packSize: string | null;
  ingredients: SourcedIngredients | null;
  directions: SourcedText | null;
  warnings: SourcedText | null;
}

export interface DeviceFacts {
  specifications: SourcedText[];
  safety: SourcedText[];
}

export interface ProductFacts {
  auroraId: string;
  kind: "cosmetic" | "set" | "device";
  description: SourcedText | null;
  ingredients: SourcedIngredients | null;
  directions: SourcedText | null;
  warnings: SourcedText | null;
  components: ProductFactComponent[];
  device: DeviceFacts | null;
  ingredientsVerified: boolean;
  showIngredientsUnverified: boolean;
}

const factsByAuroraId = productFactsJson as Record<string, ProductFacts>;

export function getProductFacts(auroraId: string | undefined): ProductFacts | null {
  if (!auroraId) return null;
  return factsByAuroraId[auroraId] ?? null;
}

export function verifiedIngredientItems(facts: ProductFacts | null): string[] {
  if (!facts) return [];
  if (facts.ingredients?.items.length) return facts.ingredients.items;
  if (facts.kind === "set") {
    return facts.components.flatMap((component) => component.ingredients?.items ?? []);
  }
  return [];
}
